import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";

export default function KH1000060009() {
  const { i18n } = useTranslation();

  if (i18n.language === "en") {
    return (
      <>
        <p>
          1. H.E. Lou Kim Chhun
          <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".b" position="right" event="both">
            Delegation of the Royal Government of Cambodia in charge as Chairman
            and CEO
          </Tooltip>
        </p>
        <p>
          2. H.E. Suy San
          <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
            (c)
          </span>
          <Tooltip target=".c" position="right" event="both">
            Member (Rep. of Ministry of Public Works and Transports)
          </Tooltip>
        </p>
        <p>
          3. H.E. Phan Phalla
          <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
            (d)
          </span>
          <Tooltip target=".d" position="right" event="both">
            Member (Rep. of Ministry of Economy and Finance)
          </Tooltip>
        </p>
        <p>
          4. H.E. Sok Sopheak
          <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
            (e)
          </span>
          <Tooltip target=".e" position="right" event="both">
            Member (Rep. of Ministry of Commerce)
          </Tooltip>
        </p>
        <p>
          5. Mr. Hun Monyvann
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (f)
          </span>
          <Tooltip target=".f" position="right" event="both">
            Member (Independent Director)
          </Tooltip>
        </p>
        <p>
          6. Mr. Hidetoshi KUME
          <span className="vertical-align-super g text-xs text-yellow-500 pl-1">
            (g)
          </span>
          <Tooltip target=".g" position="right" event="both">
            Member (Non-Executive Director, Rep. of Private Shareholders)
          </Tooltip>
        </p>
        <p>
          7. Mr. Lou Lykheng
          <span className="vertical-align-super h text-xs text-yellow-500 pl-1">
            (h)
          </span>
          <Tooltip target=".h" position="right" event="both">
            Member (Rep. of PAS's Employee)
          </Tooltip>
        </p>
      </>
    );
  }
  return (
    <>
      <p>
        ១. ឯកឧត្តម លូ គឹមឈន់
        <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".b" position="right" event="both">
          ប្រតិភូរាជរដ្ឋាភិបាលទទួលបន្ទុកជាអគ្គនាយក ក.ស.ស
        </Tooltip>
      </p>
      <p>
        ២. ឯកឧត្តម ស៊ុយ សាន
        <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
          (c)
        </span>
        <Tooltip target=".c" position="right" event="both">
          សមាជិក (តំណាងក្រសួងសាធារណការ និងដឹកជញ្ជូន)
        </Tooltip>
      </p>
      <p>
        ៣. ឯកឧត្តម ផាន់ ផល្លា
        <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
          (d)
        </span>
        <Tooltip target=".d" position="right" event="both">
          សមាជិក (តំណាងក្រសួងសេដ្ឋកិច្ច និងហិរញ្ញវត្ថុ)
        </Tooltip>
      </p>
      <p>
        ៤. ឯកឧត្តម សុខ សុភ័ក្រ្ត
        <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
          (e)
        </span>
        <Tooltip target=".e" position="right" event="both">
          សមាជិក (តំណាងក្រសួងពាណិជ្ជកម្ម)
        </Tooltip>
      </p>
      <p>
        ៥. លោក ហ៊ុន មុន្នីវណ្ណ
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (f)
        </span>
        <Tooltip target=".f" position="right" event="both">
          សមាជិក (អភិបាលឯករាជ្យ)
        </Tooltip>
      </p>
      <p>
        ៦. លោក Hidetoshi KUME
        <span className="vertical-align-super g text-xs text-yellow-500 pl-1">
          (g)
        </span>
        <Tooltip target=".g" position="right" event="both">
          សមាជិក (អភិបាលមិនប្រតិបត្តិតំណាងភាគហ៊ុនិកឯកជន)
        </Tooltip>
      </p>
      <p>
        ៧. លោក លូ លីខេង
        <span className="vertical-align-super h text-xs text-yellow-500 pl-1">
          (h)
        </span>
        <Tooltip target=".h" position="right" event="both">
          សមាជិក (តំណាងនិយោជិត ក.ស.ស)
        </Tooltip>
      </p>
    </>
  );
}
